import React from 'react';

import SwitchIcon from '@/components/Icons/icons/SwitchIcon';

interface Props {
  onClick: () => void;
}

const SwitchButton: React.FC<Props> = ({ onClick }) => {
  return (
    <div className="flex flex-start items-center gap-1" onClick={onClick}>
      <SwitchIcon color="var(--icon-highlight)" />
      <span className="text-sm font-normal text-highlight">Switch</span>
    </div>
  );
};

export default SwitchButton;
